import axios from 'axios';
import axiosInstance from './axiosInstance';
import ChangePassword from '../ChangePassword';
const BASE_URL = window.BASE_URL;

export const ManageBranchService = {
  getTitleByBranchId: (data) => axiosInstance.post(`${BASE_URL}/get_tittle`,data),
  getUsersByBranchId:(data)=> axiosInstance.post(`${BASE_URL}/get_branches_users`,data),
  addTitle: (data) => axiosInstance.post(`${BASE_URL}/add_tittle`, data),
  editTitle: (data) => axiosInstance.post(`${BASE_URL}/edit_tittle`, data),
  update: (id, data) => axiosInstance.put(`${BASE_URL}/update-title/${id}`, data),
  get_user_transactions:(data) => axiosInstance.post(`${BASE_URL}/get_user_transactions`,data),
  get_card_transactions:(data) => axiosInstance.post(`${BASE_URL}/get_card_transactions`,data),
  get_devices:(data) => axiosInstance.post(`${BASE_URL}/get_allocated_devices`,data),
  addBranchuser: (data) => axiosInstance.post(`${BASE_URL}/add_branch_user`, data),
  addAdminRecharge:(data)=> axiosInstance.post(`${BASE_URL}/add_balance_to_user`, data),
  ChangePassword:(data)=> axiosInstance.post(`${BASE_URL}/change_password`, data),
  Forgot_password:(data)=> axiosInstance.post(`${BASE_URL}/forgot_password`, data),
  GetcallTransactions:(data)=> axiosInstance.post(`${BASE_URL}/get_call_transactions`, data),
  GetOrgTransactions:(data)=>axiosInstance.post(`${BASE_URL}/get_transaction_by_org`, data),
  GetOrgStatistics:(data)=>axiosInstance.post(`${BASE_URL}/get_statistics_by_org`, data),
  GetSearchCards:(data)=>axiosInstance.post(`${BASE_URL}/search_by_cardname`, data),
  AddCardToStudent: (data) => axiosInstance.post(`${BASE_URL}/add_student`, data),
  GetCardTransactionHistory:(data)=>axiosInstance.post(`${BASE_URL}/get_card_transactions`, data),
  GetSearchStudentByMobile:(data)=>axiosInstance.post(`${BASE_URL}/search_by_mobile`, data),
  GetSearchStudentByCard:(data)=>axiosInstance.post(`${BASE_URL}/search_by_cardname`, data),
  UpdateMobileNumbers:(data)=>axiosInstance.post(`${BASE_URL}/update_mobileno`, data),
  VerifyCard:(data)=>axiosInstance.post(`${BASE_URL}/verify_card`, data),
  AddBalanceToCard:(data)=>axiosInstance.post(`${BASE_URL}/add_balance_to_card`, data),
  AddBalanceToCard:(data)=>axiosInstance.post(`${BASE_URL}/add_balance_to_card`, data),
  SwapCard:(data) => axiosInstance.post(`${BASE_URL}/exchange_card`, data),
  GetbyDeviceCode:(data) => axiosInstance.post(`${BASE_URL}/get_by_devide_code`, data),
  GetbyCardName:(data) => axiosInstance.post(`${BASE_URL}/get_by_card_name`, data), 
  GetStudentCallLogs:(data) => axiosInstance.post(`${BASE_URL}/get_student_call_logs`,data),
  UpdateDevice:(data)=> axiosInstance.post(`${BASE_URL}/update_device`,data),
  updateRechargeInfo:(data)=> axiosInstance.post(`${BASE_URL}/update_sim_recharge`,data),

};